import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { HiOutlineMail, HiOutlinePhone } from "react-icons/hi";
import { FaLinkedinIn } from "react-icons/fa";

const item = {
  hidden: { opacity: 0, y: 20, scale: 0.95 },
  show: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
};

const ContactCell = () => {
  const { t } = useTranslation();

  const links = [
    {
      icon: <HiOutlineMail className="text-lg" />,
      label: t("bento.contact.email"),
      href: `mailto:${t("contact.emailAddress")}`,
    },
    {
      icon: <HiOutlinePhone className="text-lg" />,
      label: t("bento.contact.call"),
      href: `tel:${t("contact.phoneNumber").replace(/\s/g, "")}`,
    },
    {
      icon: <FaLinkedinIn className="text-lg" />,
      label: "LinkedIn",
      href: "https://www.linkedin.com/in/axel-chevenement/",
      external: true,
    },
  ];

  return (
    <motion.div
      variants={item}
      id="contact"
      className="bento-cell p-5 lgl:p-6 flex flex-col justify-center gap-4
                 lgl:col-start-10 lgl:col-end-13 lgl:row-start-7 lgl:row-end-10"
    >
      <h3 className="text-lg font-bold text-white font-titleFont">
        {t("bento.contact.title")}
      </h3>

      <div className="flex flex-col gap-3">
        {links.map((link) => (
          <a
            key={link.label}
            href={link.href}
            target={link.external ? "_blank" : undefined}
            rel={link.external ? "noopener noreferrer" : undefined}
            className="flex items-center gap-3 p-3 rounded-xl bg-white/[0.03] border border-white/[0.06]
                       hover:bg-designColor/10 hover:border-designColor/20 transition-all duration-300 group"
          >
            <div className="text-gray-400 group-hover:text-designColor transition-colors">
              {link.icon}
            </div>
            <span className="text-sm text-gray-300 group-hover:text-white transition-colors">
              {link.label}
            </span>
          </a>
        ))}
      </div>
    </motion.div>
  );
};

export default ContactCell;
